export default "__VITE_ASSET__Bq9Xgz5i__"